/**
 * TODO: This file will be deprecated and removed in the future.
 * This HOC will be replaced with `desktop/src/app/hooks/use-initialize-cast-sender.js`.
 *
 * NOTE: This HOC is still in use in the following places and should be migrated to use the new hook:
 * - desktop/src/app/components/player/chromecast/chromecast.jsx
 * - desktop/src/app/components/series/kids/seasons-kids/episode.jsx
 * - desktop/src/app/containers/hotspot/hotspot-slide.js
 * - desktop/src/app/containers/play-button/details-play-button.js
 * - desktop/src/app/containers/play-button/showpage-play-button.js
 * - desktop/src/app/containers/series/episode.js
 * - desktop/src/app/containers/series/series-detail.jsx
 * - desktop/src/app/containers/shared/trailers/trailer.js
 * - desktop/src/app/containers/title/title-detail.jsx
 */
import {
  connect
} from 'react-redux'
import { path, prop } from 'ramda'
import { compose, withHandlers } from 'recompose'
import { withApollo } from 'react-apollo'

import {
  selectDataSaverOption
} from '../actions'
import getDeviceInfo from '../lib/device-info'
import { getToken } from '../lib/storage'
import withDeviceFingerprint from './with-device-fingerprint'

import CONTENT_ITEM_QUERY from '../../graphql/queries/content-item.gql'
import CONFIG_QUERY from '../../graphql/queries/config.gql'
import ACCOUNT_QUERY from '../../graphql/queries/account.gql'
import { getAccountIdFromState } from '../selectors/session'
// Higher order component to manage loading screen on mutations

const withInitializeCastSender = compose(
  withApollo,
  withDeviceFingerprint,
  // connecting to Redux Store:
  // https://github.com/reactjs/react-redux/blob/master/docs/api.md#connectmapstatetoprops-mapdispatchtoprops-mergeprops-options
  connect(
    // mapStateToProps
    (state) => {
      const getOptionSelected = path(['user', 'account', 'dataSaver'])
      const getCastSender = prop('castSender')
      return {
        selectedDataSaverOption: getOptionSelected(state),
        castSender: getCastSender(state),
        accountId: getAccountIdFromState(state)
      }
    },
    // mapDispatchToProps
    (dispatch) => { // define handlers that use dispatch to dispatch actions, pass dispatch
      return {
        dispatchSelectDataSaver: (dataSaverOption, accountId) => {
          dispatch(selectDataSaverOption(dataSaverOption, accountId))
        }
      }
    },
    // mergeProps
    (
      { accountId, ...stateProps },
      { dispatchSelectDataSaver, ...dispatchProps },
      ownProps
    ) => ({
      ...ownProps,
      ...stateProps,
      ...dispatchProps,
      selectDataSaver: (dataSaverOption) => {
        dispatchSelectDataSaver(dataSaverOption, accountId)
      }
    })
  ),
  withHandlers({
    maybeInitializeCastSender: ({
      history,
      client,
      selectDataSaver,
      selectedDataSaverOption,
      castSender,
      deviceFingerprint
    }) => (url, contentItem, isTrailer) => {
      if (castSender.isConnected) {
        const deviceInformation = {
          ...getDeviceInfo(),
          uuid: deviceFingerprint,
          platform: 'Web'
        }
        window.castPlayer.loadMedia({
          apolloClient: client,
          selectDataSaverFunction: selectDataSaver,
          selectedDataSaverOption,
          contentItemQuery: {
            query: CONTENT_ITEM_QUERY,
            variables: {
              id: contentItem.id
            }
          },
          isVideoExtra: isTrailer,
          deviceUUID: deviceInformation.uuid,
          configQuery: {
            query: CONFIG_QUERY,
            variables: {
              input: {
                deviceInfo: deviceInformation
              }
            }
          },
          accountQuery: {
            query: ACCOUNT_QUERY
          },
          contentItemId: contentItem.id,
          app_token: getToken()
        })
      } else if (history) {
        history.push(url)
      }
    },
    castPreviewPageSender: ({ castSender }) => (contentItem) => {
      if (castSender.isConnected) {
        window.castPlayer.loadPreviewPage(contentItem)
      }
    }
  })
)

export default withInitializeCastSender
